// extracted by mini-css-extract-plugin
module.exports = {"markdown":"markdown_markdown__BL44X"};